import { JsonProperty, JsonObject } from 'typescript-json-serializer';

/**
 * Container class for driver history item
 *
 * @export
 * @class DriverHistory
 */
@JsonObject()
export class DriverHistory {
  @JsonProperty('StationID') stationId: string;
  @JsonProperty('StationName') stationName: string;
  @JsonProperty('StartTime') startTime: Date;
  @JsonProperty('Durration') duration: number;
  @JsonProperty('Consumption') consumption: number;
  @JsonProperty('PriceConsumption') consumptionPrice: number;
  @JsonProperty('PriceParkingTime') parkingPrice: number;
  @JsonProperty('PriceUnit') currencyCode: string;
  @JsonProperty('PricePenalty') penaltyPrice: number;
  @JsonProperty('StationUserID') stationUserId: string;
  @JsonProperty('SignedTransaction') transaction: string;
  @JsonProperty('PublicKey') publicKey: string;
}
